import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-svg-loading-dark',
  templateUrl: './svg-loading-dark.component.html',
  styleUrls: ['./svg-loading-dark.component.css']
})
export class SvgLoadingDarkComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
